module.exports = __webpack_public_path__ + "img/queue-5g.ec44339e.png";